import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Employee from 'employees/components/form';

const EmployeesFormView = ({
  t,
  employee,
  customfields,
  company,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  isSaving,
  handleCustomFieldChange,
  handleGroupChange,
  groups,
  activeImage,
  onDragEnter,
  onDragLeave,
  handleFileSelected,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("employees.employees_title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('employees.title') +
          ' > ' +
          t(employee.id ? 'employees.edit' : 'employees.add')
        }
        icon={'archive'}
      >
        <Employee.Form
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          subcompany={subcompany}
          values={employee}
          customFields={customfields}
          handleGroupChange={handleGroupChange}
          handleCustomFieldChange={handleCustomFieldChange}
          groups={groups}
          activeImage={activeImage}
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          handleFileSelected={handleFileSelected}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(EmployeesFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/EmployeeFormView.js